import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EfCardCommon, { EfCardCommonProps } from '@elem/ui/ef-card-common';
import { useState } from 'react';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('fourinone.teaser');

    const { locale } = getLocal();
    const listA = [
        {
            theme: 'white',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724145976017/product_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724208271666/product_4_h5.jpg',
            title: t('river3_banner_title'),
            desc: t('river3_banner_desc'),
            moreLink: `https://www.ecoflow.com/${locale}/river-3-series-portable-power-station`,
            moreText: t('river3_banner_btn_1'),
            // buyLink: `https://${locale}.ecoflow.com/collections/river-3-series`,
            // buyText: t('river3_banner_btn_2'),
            label: t('river3_banner_label'),
        },
        {
            theme: 'white',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724145976014/product_5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724208544442/product_5_h5.jpg',
            title: t('rapid_banner_title'),
            desc: t('rapid_banner_desc'),
            moreLink: `https://www.ecoflow.com/${locale}/rapid-magnetic-power-bank`,
            moreText: t('rapid_banner_btn_1'),
            // buyLink: `https://${locale}.ecoflow.com/products/rapid-magnetic-power-bank`,
            // buyText: t('rapid_banner_btn_2'),
            label: t('rapid_banner_label'),
        },
    ];
    return (
        <>
            <div className="space-lt"></div>
            <div className={styles.TheComp}>
                {listA.map((item: EfCardCommonProps, index: number) => {
                    return (
                        <div key={index} className="ListA-item">
                            <EfCardCommon {...item} isCloseGloCardLink={true} gtm_position="Product Preview" />
                        </div>
                    );
                })}
            </div>
        </>
    );
}
